#import "../fragments/wf-form-fragment.graphql"

mutation ConnectedFormActivate($input: ConnectedFormActivateInput!) {
    connectedFormActivate(input: $input) {
        connectedForm {
            ...WfFormFragment
        }
    }
}
